import Analytics from '../../ui/util/Analytics';

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <Analytics />
  </>
);
